import { useReadLocalStorageBase } from '@/core/hooks';
// Overrides only needed to get `T` as return value, instead of `T | null` when initial`Value is specified
export function useAppReadLocalStorage({ key, initialValue, options }) {
    return useReadLocalStorageBase(key, initialValue, options);
}
